import { render, staticRenderFns } from "./Jgdt.vue?vue&type=template&id=3c36cbca&scoped=true&"
import script from "./Jgdt.vue?vue&type=script&lang=js&"
export * from "./Jgdt.vue?vue&type=script&lang=js&"
import style0 from "./Jgdt.vue?vue&type=style&index=0&id=3c36cbca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c36cbca",
  null
  
)

export default component.exports